// @flow
import { setDepartureDate } from 'Store/trip-criteria/departure-date/departureDate.action';
import { getDepartureDate } from 'Store/trip-criteria/tripCriteria.selector';
import { createOptimisticAction } from 'Store/utils/createAction';
import {
  loadChildcareAvailabilities,
  loadPrices,
  loadProductsWithIds,
  searchWithFacets,
  type FacetingChildcareCriteria,
  type FacetingPricesCriteria,
} from 'Store/utils/searchHelper';
import { isDateInThePast } from 'Utils/faceting/facetingUtils';
import {
  FACETING_CHILDCARE_REQUEST,
  FACETING_LOAD_PRODUCTS_REQUEST,
  FACETING_PRICES_REQUEST,
  FACETING_SEARCH_REQUEST,
} from './constants';
import { facetingCriteriaSelector, searchQuerySelector } from './faceting.selector';

type FacetingSearchRequestParams = {
  appContext: AppContext,
  options: FacetingSearchOptions,
};
export function facetingSearchRequest({ appContext, options = {} }: FacetingSearchRequestParams) {
  return (dispatch: ReduxDispatch, getState: GetReduxState) => {
    const state = getState();
    const departureDate = getDepartureDate(state);
    if (departureDate && isDateInThePast(departureDate)) {
      dispatch(setDepartureDate(null));
    }

    const { boutique, defaultDepartureCity, offerId, productIds, screenSize } = options;
    const { label: query } = searchQuerySelector(state);
    const facetingCriteria = facetingCriteriaSelector(state);
    const criteria = {
      ...facetingCriteria,
      boutique,
      defaultDepartureCity,
      offerId,
      productIds,
      query,
      screenSize,
    };
    const promise = searchWithFacets({ criteria, options, appContext });
    return dispatch(
      createOptimisticAction(FACETING_SEARCH_REQUEST, {}, { optimist: true, promise }),
    );
  };
}

type FacetingLoadProductsRequestParams = {
  appContext: AppContext,
  productIds: Array<*>,
};
export function facetingLoadProductsRequest({
  appContext,
  productIds = [],
}: FacetingLoadProductsRequestParams) {
  return (dispatch: ReduxDispatch) => {
    const promise = loadProductsWithIds({ appContext, productIds });
    return dispatch(
      createOptimisticAction(FACETING_LOAD_PRODUCTS_REQUEST, {}, { optimist: true, promise }),
    );
  };
}

type PricesRequestActionParams = {|
  appContext: AppContext,
  criteria: FacetingPricesCriteria,
|};

export function pricesRequestAction({ appContext, criteria }: PricesRequestActionParams) {
  const promise = loadPrices({ appContext, criteria });
  return createOptimisticAction<*, *>(FACETING_PRICES_REQUEST, {}, { optimist: true, promise });
}

type ChildcareRequestActionParams = {|
  appContext: AppContext,
  criteria: FacetingChildcareCriteria,
|};

type FacetingChildcareAvailabilities = {
  childcareSearch: {
    id: string,
    productId: string,
    availability: string, // enum actually
    isIncluded: boolean,
    ageMin: number,
    ageMax: number,
    remainingStock: ?number,
  },
};
export function childcareRequestAction({
  appContext,
  criteria = {},
}: ChildcareRequestActionParams) {
  const promise = loadChildcareAvailabilities({
    appContext,
    criteria,
  });
  return createOptimisticAction<FacetingChildcareAvailabilities, *>(
    FACETING_CHILDCARE_REQUEST,
    {},
    { optimist: true, promise },
  );
}
